import React from 'react';
import FormStepRilis from './child/FormStepRilis';

const ReleaseLayer = () => {
   return (
      <>
        <FormStepRilis />
      </>
   );
};

export default ReleaseLayer;